/* eslint-disable react/no-danger */

import './ListingBanner.scss';

function lazyLoadImages(rawHtml: string) {
    return rawHtml.replace(/<img\b([^>]*?)>/g, (_match, attrs) => `<img fetchpriority="high" ${attrs}>`);
}

export default function ListingBanner({ banner }: { banner: string }) {
    return (
        <div
            className="listing-header"
            dangerouslySetInnerHTML={{ __html: lazyLoadImages(banner) }}
        />
    );
}
